import React from 'react';
import bannerImg from '../../../icons/data-banner.jpg';
import './styles.scss';

function Banner() {
    return (
        <section className="mainBanner">
            <div
                className="bannerImg verticalSpace"
                style={{ backgroundImage: `url('${bannerImg}')` }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 text-md-left text-center">
                            <h1 className="f-64 p-0 extraBold">Open Data</h1>
                            <p className="bannerDescriptionText">
                                {`Litterati's goal is to empower people to collect Litter Data &
                                to empower people with access to that data so that anyone can
                                help to create a litter-free world.`}
                                {/*Litterati is powered by a worldwide community of
                                individuals working to create a litter-free
                                world. The data collected is openly shared to
                                empower anyone to create a greater environmental
                                impact.*/}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <p className="belowBannerDescriptionText">
                Download custom data subsets from our Global Litter Database.
                The below tool can help you generate data reports of up to{' '}
                <b>50,000</b> pieces of litter.
            </p>
        </section>
    );
}

export default Banner;
